export interface Settings {
    apiBaseUrl: string;
    googleRecaptchaKey: string;
}

const settings: Settings = {
    apiBaseUrl: '',
    googleRecaptchaKey: '',
};

export default settings;